var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.12,
    height: 25.888,
    viewBox: "0 0 30.12 25.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mark_email_read_FILL0_wght400_GRAD0_opsz48",
    d: "M23.5,33.388l-5.677-5.677,1.516-1.516L23.5,30.356l8.6-8.6,1.516,1.516ZM18.034,17.626l11.777-7.511H6.257Zm0,2.116L6.116,12.09V28.028h9.027l2.116,2.116H6.116a2.03,2.03,0,0,1-1.481-.635A2.03,2.03,0,0,1,4,28.028V10.116a2.03,2.03,0,0,1,.635-1.481A2.03,2.03,0,0,1,6.116,8H29.988A2.169,2.169,0,0,1,32.1,10.116v8.6l-2.116,2.116V12.09ZM18.069,20.059ZM18.034,17.626ZM18.069,19.742Z",
    transform: "translate(-3.75 -7.75)",
    fill: "#464b8e",
    stroke: "#464b8e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMessage);
export default __webpack_public_path__ + "static/media/logo-message.2b9380afcca4d0927d3e46d95391c3fb.svg";
export { ForwardRef as ReactComponent };